// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__32zsp","buttons":"PendingPaymentAlert_buttons__1ipG5"};